export function processQueueCoverage(data, pbxMap) {
 const queueMap = pbxMap?.call_queues;
 const allQueuesStats = data?.data[0]?.queues || [];
 const timeSlots = data.summary.unique_periods || [];
 const userDn = data?.data[0]?.user_dn;

 const userQueueConnectionPercentages = [];
 const userConnectionPercentages = [];
 const userAvailabilityPercentages = [];

 timeSlots?.forEach(time => {
  let totalConnectedPercentage = 0;
  let totalAvailabilityPercentage = 0;
  let queueCountForPeriod = 0;
  let totalMinutesConnectedForPeriod = 0;
  let totalMinutesForPeriod = 0;
  let totalMinutesAvailableForPeriod = 0;

  allQueuesStats.forEach(queue => {
   const stat = queue.period_stats.find(
    p => p.time_period === time && p.user_dn === userDn
   );
   if (stat) {
    totalMinutesConnectedForPeriod +=
     parseInt(stat.total_minutes_connected_pbx_in_period) || 0;
    totalMinutesForPeriod += parseInt(stat.total_minutes_in_period) || 0;
    totalMinutesAvailableForPeriod += parseInt(stat.minutes_available) || 0;
    totalConnectedPercentage +=
     parseFloat(stat.queue_connection_percentage) || 0;
    totalAvailabilityPercentage +=
     parseFloat(stat.availability_percentage) || 0;
    queueCountForPeriod++;
   }
  });

  userConnectionPercentages.push(
   totalMinutesForPeriod > 0
    ? (totalMinutesConnectedForPeriod / totalMinutesForPeriod) * 100
    : 0
  );
  userQueueConnectionPercentages.push(
   queueCountForPeriod > 0 ? totalConnectedPercentage / queueCountForPeriod : 0
  );
  userAvailabilityPercentages.push(
   totalMinutesConnectedForPeriod > 0
    ? (totalMinutesAvailableForPeriod / totalMinutesConnectedForPeriod) * 100
    : 0
  );
 });

 const lineChartSeries = [
  {
   name: "Connexion utilisateur % (moyenne)",
   data: userConnectionPercentages,
  },
  {
   name: "Disponibilité utilisateur % (moyenne)",
   data: userAvailabilityPercentages,
  },
 ];

 // --- Data for Bar Chart (User's total minutes) ---
 const userTotalMinutes = [];
 const userConnectedMinutes = [];
 const userQueueConnectedMinutes = [];
 const userAvailableMinutes = [];

 timeSlots.forEach(time => {
  let periodTotal = 0;
  let periodConnected = 0;
  let queueConnected = 0;
  let periodAvailable = 0;

  allQueuesStats.forEach(queue => {
   const stat = queue.period_stats.find(
    p => p.time_period === time && p.user_dn === userDn
   );
   if (stat) {
    periodTotal += parseInt(stat.total_minutes_in_period, 10) || 0;
    periodConnected +=
     parseInt(stat.total_minutes_connected_pbx_in_period, 10) || 0;
    queueConnected =
     parseInt(stat.minutes_connected_to_queue, 10) > queueConnected
      ? parseInt(stat.minutes_connected_to_queue, 10)
      : queueConnected;
    periodAvailable += parseInt(stat.minutes_available, 10) || 0;
   }
  });
  userTotalMinutes.push(periodTotal / allQueuesStats?.length);
  userConnectedMinutes.push(periodConnected / allQueuesStats?.length);
  userQueueConnectedMinutes.push(queueConnected);
  userAvailableMinutes.push(periodAvailable / allQueuesStats?.length);
 });

 const barChartSeries = [
  {
   name: "Minutes totales",
   data: userTotalMinutes,
  },
  {
   name: "Minutes connectées",
   data: userConnectedMinutes,
  },
  {
   name: "Minutes connectées à la file",
   data: userQueueConnectedMinutes,
  },
  {
   name: "Minutes disponibles",
   data: userAvailableMinutes,
  },
 ];

 // --- Data for Area Chart (User's time utilization) ---
 const areaChartSeries = [
  {
   name: "Disponible",
   data: barChartSeries[3].data,
  },
  {
   name: "Indisponible",
   data: barChartSeries[3].data.map(
    (val, i) => barChartSeries[1].data[i] - val // Available - Connected
   ),
  },
  //   {
  //    name: "User Unavailable Time",
  //    data: barChartSeries[0].data.map(
  //     (val, i) => val - barChartSeries[2].data[i] // Total - Available
  //    ),
  //   },
 ];

 // --- Data for Heatmap (User's connection to individual queues) ---
 const heatmapSeries = allQueuesStats.map(queue => {
  const queueData = timeSlots.map(time => {
   const stat = queue.period_stats.find(
    p => p.time_period === time && p.user_dn === userDn
   );
   return {
    x: time,
    y: stat ? parseFloat(stat.queue_connection_percentage) || 0 : 0, // Show minutes connected for this queue
   };
  });
  return {
   name: `${queue.queue_dn} - ${queueMap[queue?.queue_dn]?.name}`,
   data: queueData,
  };
 });

 return {
  timeSlots,
  lineChartSeries,
  barChartSeries,
  areaChartSeries,
  heatmapSeries,
 };
}

export function processOverviewData(data) {
 if (!data)
  return { donutSeries: [], radialSeries: [], pbxConnectedSeries: [] };

 const totalConnectedMinutes = parseInt(data.total_connected_minutes, 10) || 0;
 const pbxConnectedPercentage =
  parseInt(data.pbx_connection_percentage, 10) || 0;
 const queueConnectedPercentage =
  parseInt(data.queue_connection_percentage, 10) || 0;
 const availableMinutes = parseInt(data.available_records, 10) || 0;
 const totalPossibleMinutes = parseInt(data.total_records, 10) || 0;
 const unavailableMinutes =
  totalPossibleMinutes - totalConnectedMinutes - availableMinutes;

 return {
  donutSeries: [totalConnectedMinutes, availableMinutes, unavailableMinutes],
  pbxConnectedSeries: {
   labels: ["Connecté au PBX"],
   series: pbxConnectedPercentage,
  },
  queueConnectedSeries: {
   labels: ["Connecté à la file"],
   series: queueConnectedPercentage,
  },
  radialSeries: [
   parseFloat(data.queue_connection_percentage) || 0,
   parseFloat(data.availability_percentage) || 0,
   parseFloat(data.pbx_connection_percentage) || 0,
  ],
 };
}

export function processStatusBreakdown(data) {
 if (!Array.isArray(data.data))
  return { labels: [], series: [], radialSeries: [] };

 const labels = data.data.map(status => status.status_name);
 const totalMinutesArray = data.data.map(
  status => parseFloat(status.total_minutes) || 0
 );

 const barSeriesInHours = totalMinutesArray.map(minutes => minutes / 60);

 const grandTotalMinutes = totalMinutesArray.reduce(
  (sum, current) => sum + current,
  0
 );
 const radialSeriesPercentages = totalMinutesArray.map(minutes =>
  grandTotalMinutes > 0 ? (minutes / grandTotalMinutes) * 100 : 0
 );

 return {
  labels: labels,
  series: barSeriesInHours, // for Bar Chart
  radialSeries: radialSeriesPercentages, // for RadialBar Chart
 };
}
